import type {CreateJobFormData} from '../types';
import '../types';
import {ADMIN_CREATE_JOB_VARIANT_CONFIGS} from '../consts';

const getAllVariantsDefined = (formValues: CreateJobFormData) => {
	const stringIndexedFormValues = formValues as Record<string, any>;
	const isDefined = Object.keys(ADMIN_CREATE_JOB_VARIANT_CONFIGS).reduce((acc, val) => {
		if (!stringIndexedFormValues[val] || !stringIndexedFormValues[val].version) {
			return false;
		}

		return acc;
	}, true);
	return isDefined;
};

export default getAllVariantsDefined;
